import { DefaultConfig } from "@/config";
import type { AppConfigDefinition } from "@/types";

export function useAppConfig(): AppConfigDefinition {
  // lexojmë nga provide dhe nëse mungon, përdorim defaultConfig
  const config = inject<AppConfigDefinition>("customConfig", DefaultConfig);
  return config;
}